import type { ApiRoute, NoPathParams, NoQueryParams } from "../api"
import type { InventoryListFilterValue } from "./InventoryListFilterValue"
import type { SmartSearchRequest } from "./SmartSearchRequest"

export const getSmartSearchResultRoute: ApiRoute<
	NoPathParams,
	NoQueryParams,
	SmartSearchRequest,
	InventoryListFilterValue
> = {
	buildUrl: () => "/inventory-smart-search",
	method: "post",
	path: "/inventory-smart-search",
}
